








































import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'AppToolbar'
})
export default class AppToolbar extends Vue {
  private showPageSet (): void {
    this.$emit('showPageSet')
  }

  private showPreview (): void {
    this.$emit('showPreview')
  }

  private saveAll (): void {
    this.$emit('savePageSet')
  }

  private reset (): void {
    this.$emit('reset')
  }
}
